import './Avatar.scss';
import { AvatarParams } from './Avatar.type';
import { isPureNumber, filterInvalidText, hasChinese } from '@utils/string';
import { AvatarType, UserDistrict } from '@tencent/wemeet-websdk-next';
import { getAvatarUrlByToken } from '@utils/wemmet';

export default function Avatar(props: AvatarParams) {
  const {
    mode = 'small',
    nickname = '',
    avatarToken = '',
    avatarType = AvatarType.default,
    userDistrict = UserDistrict.oversea,
  } = props;

  const avatarUrl = getAvatarUrlByToken({ avatarToken, userDistrict });

  /** 是否有头像图片 */
  const hasAvatarImg = (avatarType: AvatarType) => avatarType === AvatarType.corp || avatarType === AvatarType.custom;

  /**
   * @description 解析用户名，生成默认头像中的文字
   * @return {string}
   * */
  const getAbbrFromNickname = (nickname = '') => {
    const pureNickName = filterInvalidText(nickname);
    let nicknameAbbr = pureNickName.substring(0, 1).toUpperCase();

    if (hasChinese(pureNickName) || isPureNumber(pureNickName)) {
      nicknameAbbr = pureNickName.substring(pureNickName.length - 2);
    }
    return nicknameAbbr;
  };

  return (
    <span className={`avatar avatar--${mode}`}>
      {hasAvatarImg(avatarType) ? (
        <img className={'avatar__img'} src={avatarUrl} />
      ) : (
        <span className={'avatar__nickname'}>{getAbbrFromNickname(nickname)}</span>
      )}
    </span>
  );
}
